import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { getFormattedValue } from "../../../../utils/previewValueFormatterUtils";
import { PreviewCardLayout } from "./PreviewCardLayout";

interface ProfileFieldCardProps {
  params: Record<string, string | string[]>;
  url: string;
}

export const ProfileFieldCard = ({ params, url }: ProfileFieldCardProps) => {
  const PROFILE_FIELDS = {
    label: { label: t("profile_fields.field_modal.label"), type: "string" },
    field_type: {
      label: t("profile_fields.field_modal.field_type"),
      type: "string",
    },
    key: { label: t("profile_fields.field_modal.key"), type: "string" },
    placeholder: {
      label: t("profile_fields.field_modal.placeholder_name"),
      type: "string",
    },
    description: {
      label: t("profile_fields.field_modal.description_name"),
      type: "string",
    },
    choices: {
      label: t("profile_fields.field_modal.choices"),
      type: "array",
    },
    number_format: {
      label: t("profile_fields.field_modal.format"),
      type: "humanize",
    },
    number_decimal: {
      label: t("profile_fields.field_modal.decimal"),
      type: "string",
    },
    required: {
      label: t("profile_fields.field_modal.required"),
      type: "boolean",
    },
    hidden: { label: t("profile_fields.field_modal.hidden"), type: "boolean" },
    signup: { label: t("profile_fields.pages.signup.title"), type: "boolean" },
    edit_profile: {
      label: t("profile_fields.pages.edit_profile.title"),
      type: "boolean",
    },
    profile_view: {
      label: t("profile_fields.pages.profile_view.title"),
      type: "boolean",
    },
    community_view: {
      label: t("profile_fields.pages.community_view.title"),
      type: "boolean",
    },
  };

  return (
    <PreviewCardLayout
      title={t(
        "help_widget.copilot.preview_cards.create_profile_field_card_title",
      )}
      url={url}
    >
      <ul className="flex flex-col leading-5">
        {Object.entries(PROFILE_FIELDS).map(
          ([key, keyProps]) =>
            params[key] && (
              <li key={key} className="!pb-0">
                <Typography.BodySm color="text-dark">
                  <strong>{keyProps.label}:</strong>{" "}
                  {getFormattedValue(params[key], keyProps.type)}
                </Typography.BodySm>
              </li>
            ),
        )}
      </ul>
    </PreviewCardLayout>
  );
};
